/**
 * Pulls the server dex as soon as a Pro trainer is signed in and the tier is
 * known, so a fresh install's Profile shows the real counts instead of zeros
 * until the Dex page is opened. See lib/dexSyncOnSignIn for the why.
 */
import { useEffect } from "react";
import { useAuth } from "@/components/AuthProvider";
import { hasProAccess, useSession } from "@/components/SessionProvider";
import { apiRequestRaw } from "@/lib/queryClient";
import { syncDexOnSignIn } from "@/lib/dexSyncOnSignIn";

export function DexSyncOnSignIn(): null {
  const { isSignedIn, token } = useAuth();
  const { tier, tierSettled } = useSession();

  useEffect(() => {
    if (!isSignedIn || !token || !tierSettled) return;
    void syncDexOnSignIn({ token, isPro: hasProAccess(tier), apiFetch: apiRequestRaw });
  }, [isSignedIn, token, tier, tierSettled]);

  return null;
}
